import { Block, BlockNoteEditor, BlockSchema } from '@blocknote/core';
import { BlockNoteView } from '@blocknote/mantine';
import { Box, Button, Flex } from '@chakra-ui/react';
import React, { ReactElement, useEffect, useMemo } from 'react';
import { createEditorWithMode } from 'utils/createEditorWithMode';

import 'styles/worksheets/styles.css';

type Props<T extends BlockSchema> = {
  originDocument: Block<T>[] | null;
  schema: BlockNoteEditor<T>['schema'];
  showResetButton?: boolean;
};

export const WorksheetPreview = <T extends BlockSchema>({
  originDocument,
  schema,
  showResetButton = true,
}: Props<T>): ReactElement => {
  const [editorKey, setEditorKey] = React.useState<number>(0);
  const editor = useMemo(() => {
    if (!originDocument || originDocument.length === 0) {
      return createEditorWithMode('student', { schema });
    }
    return createEditorWithMode('student', {
      schema,
      initialContent: originDocument,
    });
  }, [originDocument, schema]);

  useEffect(() => {
    if (editor && originDocument) {
      editor.replaceBlocks(editor.document, originDocument);
    }
  }, [editor, originDocument]);

  const handleResetPreview = (): void => {
    if (!originDocument) return;
    editor.replaceBlocks(editor.document, originDocument);
    setEditorKey((prevKey) => prevKey + 1);
  };

  return (
    <Box>
      <BlockNoteView
        slashMenu={false}
        editable={false}
        editor={editor}
        style={{
          width: '100%',
        }}
        data-theming-css-variables
        key={editorKey} // Force re-render when originDocument changes
      />
      {showResetButton && (
        <Flex justifyContent="center" marginTop="16px">
          <Button variant="primary" onClick={handleResetPreview}>
            Vorschau zurücksetzen
          </Button>
        </Flex>
      )}
    </Box>
  );
};
